import {combineReducers} from 'redux';
import webmodule from './webmodule/reducers';
import layout from './layout/reducers';
import auth from './auth/reducers';
import tutorial from './tutorial/reducer';

export default combineReducers({
  webmodule,
  layout,
  auth,
  tutorial,
});
